// Signal to the CSP-safe network overlay in public/index.html that the JS
// bundle successfully loaded and executed. If this bundle is blocked (e.g.
// accessed outside the Toyota secure network / Zscaler), this line never runs
// and the "Network Access Required" message in index.html is revealed instead.
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { getMsalInstance } from "authInstance";
import { store, persistor } from "./api-store/store"; // Ensure correct path
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Bounce, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Adding this class hides the boot/network overlay defined in public/index.html.
// Setting a class via the DOM API is not restricted by the site's
// Content-Security-Policy (unlike inline scripts), so this is CSP-safe.
document.documentElement.classList.add("app-booted");

const msalInstance = getMsalInstance();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
            <ToastContainer
              theme="light"
              pauseOnHover
              transition={Bounce}
              autoClose={7000}
              position="bottom-right"
              icon={false}
            />
          </PersistGate>
        </Provider>
      </MsalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
